module.exports = __webpack_public_path__ + "img/jackpot.96b77091.png";